module.exports = __webpack_public_path__ + "img/heuristic-evaluation-1.24d840d3.png";